// 工单类型
const typeUrl = '/business/workOrderType/'
// 工单
const orderUrl = '/business/workOrder/'

export default {
  selectWorkOrderTypeByList: typeUrl + 'selectWorkOrderTypeByList',
  insertWorkOrderType: typeUrl + 'insertWorkOrderType',
  updateWorkOrderType: typeUrl + 'updateWorkOrderType',
  selectWorkOrderTypeByType: typeUrl + 'selectWorkOrderTypeByType',
  deleteDataWorkOrderType: typeUrl + 'deleteDataWorkOrderType',
  onOffWorkOrderType: typeUrl + 'onOffWorkOrderType',
  selectOrderTypeFeedbackUserByList: typeUrl + 'selectOrderTypeFeedbackUserByList',
  selectOrderTypeApproveUserByList: typeUrl + 'selectOrderTypeApproveUserByList',

  selectWorkOrderByPage: orderUrl + 'selectWorkOrderByPage',
  insertWorkOrder: orderUrl + 'insertWorkOrder',
  selectWorkOrderByOrderId: orderUrl + 'selectWorkOrderByOrderId',
  insertThisWorkOrderFlowOwn: orderUrl + 'insertThisWorkOrderFlowOwn',
  insertThisWorkOrderFlowTwo: orderUrl + 'insertThisWorkOrderFlowTwo',
  insertThisWorkOrderFlowClose: orderUrl + 'insertThisWorkOrderFlowClose',
  insertYhWoPass: orderUrl + 'insertYhWoPass',
  insertWorkOrderFlowTwo: orderUrl + 'insertWorkOrderFlowTwo',
  insertWorkOrderFlowClose: orderUrl + 'insertWorkOrderFlowClose',
  pressingWorkOrder: orderUrl + 'pressingWorkOrder',

  // 导出养护工单 word/excal
  exportLcWorkOrderWord:'/business/lcWorkOrder/exportLcWorkOrderWord',
  exportLcWorkOrderExcel:'/business/lcWorkOrder/exportLcWorkOrderExcel',

  // 导出问题工单 word/excal
  exportLcIssueWord:'/business/lcPatrolIssue/exportLcIssueWord',
  exportLcIssueExcel:'/business/lcPatrolIssue/exportLcIssueExcel'
}
